import { getAdminAxiosInstance } from '../../../api/Admin';

export const createPlaceholder = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/search/store`, params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deletePlaceholder = async (id) => {
  const api = await getAdminAxiosInstance();

  try {
    const response = await api.delete(`/search/delete?search_id=${id}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};